module.exports = __webpack_public_path__ + "static/media/tig-logo-white.d8a71a1f.svg";